import { useState, useRef } from "react";
import { ref, get, set } from "firebase/database";
import { database } from "../Doctor/Firebase/firebase.config";

/* ─── Autosuggest data ─── */
const DEGREES = [
  "MBBS","BDS","BAMS","BUMS","BHMS","B.Sc Nursing","GNM","B.Pharm","M.Pharm",
  "MD","MS","MDS","DNB","DM","MCh","Diploma in Nursing","BSc MLT","BSc Radiography",
  "MBA Healthcare","MPT","BPT","DMLT","BSc Optometry","PhD Medical",
];
const SPECS = [
  "Cardiology","Orthopaedics","Neurology","Paediatrics","Gynaecology",
  "General Surgery","Anaesthesiology","Radiology","Dermatology","Ophthalmology",
  "ENT","Psychiatry","Oncology","Nephrology","Urology","ICU / Critical Care",
  "Emergency Medicine","Dental Surgery","Physiotherapy","Ayurveda","Homeopathy",
];
const INSTS = [
  "AIIMS New Delhi","AIIMS Mumbai","KEM Hospital Mumbai","Safdarjung Hospital",
  "Maulana Azad Medical College","Grant Medical College","Seth GS Medical College",
  "Manipal College of Medical Sciences","CMC Vellore","JIPMER Puducherry",
  "St John's Medical College","Kasturba Medical College","JSS Medical College",
  "Amrita Institute","DY Patil Medical College","Ruby Hall Clinic College",
  "BJ Medical College Pune","Sassoon General Hospital",
];
const JOB_TITLES = [
  "General Physician","Resident Doctor","Medical Officer","Dentist","Surgeon",
  "Physiotherapist","Staff Nurse","ICU Nurse","OT Technician","Lab Technician",
  "Radiographer","Pharmacist","Ayurvedic Practitioner","Medical Superintendent",
  "Healthcare Administrator","Paramedic","Health Assistant","Dental Surgeon",
];

/* ─── Styles ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&family=Poppins:wght@500;600;700&display=swap');
  .am-overlay{position:fixed;inset:0;background:rgba(5,30,40,.6);backdrop-filter:blur(4px);z-index:3000;display:flex;align-items:center;justify-content:center;padding:16px;}
  .am-modal{background:#fff;border-radius:22px;width:100%;max-width:500px;max-height:92vh;overflow-y:auto;box-shadow:0 24px 60px rgba(13,115,119,.25);font-family:'Nunito',sans-serif;}
  .am-header{background:linear-gradient(135deg,#0d7377,#14a085);padding:22px 24px 18px;border-radius:22px 22px 0 0;position:relative;}
  .am-header h2{font-family:'Poppins',sans-serif;font-size:1.15rem;font-weight:600;color:#fff;margin-bottom:3px;}
  .am-header p{color:rgba(255,255,255,.8);font-size:.85rem;}
  .am-close{position:absolute;top:14px;right:14px;width:30px;height:30px;border-radius:50%;background:rgba(255,255,255,.2);border:none;color:#fff;font-size:1rem;cursor:pointer;display:flex;align-items:center;justify-content:center;}
  .am-close:hover{background:rgba(255,255,255,.35);}
  .am-back{position:absolute;top:14px;left:14px;width:30px;height:30px;border-radius:50%;background:rgba(255,255,255,.2);border:none;color:#fff;font-size:1rem;cursor:pointer;display:flex;align-items:center;justify-content:center;}
  .am-back:hover{background:rgba(255,255,255,.35);}
  .am-body{padding:22px 24px 26px;}
  .am-pills{display:flex;gap:6px;margin-bottom:16px;}
  .am-pill{height:3px;border-radius:2px;background:#d5eef0;flex:1;transition:background .2s;}
  .am-pill.done{background:#0d7377;}
  .am-step-label{font-size:.82rem;font-weight:700;color:#5a8a94;margin-bottom:14px;}

  /* Role cards */
  .am-role-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;}
  .am-role-card{border:1.5px solid #c5e5e8;border-radius:14px;padding:18px 10px;text-align:center;cursor:pointer;transition:all .18s;background:#f5fcfd;}
  .am-role-card:hover{border-color:#0d7377;background:#e0f7f3;}
  .am-role-icon{font-size:1.8rem;margin-bottom:8px;}
  .am-role-label{font-family:'Poppins',sans-serif;font-size:.88rem;font-weight:600;color:#0d4a55;}
  .am-role-sub{font-size:.75rem;color:#6a9aa2;margin-top:3px;}

  /* Auth choice */
  .am-auth-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
  .am-auth-card{border:1.5px solid #c5e5e8;border-radius:14px;padding:20px 14px;text-align:center;cursor:pointer;transition:all .18s;background:#f5fcfd;}
  .am-auth-card:hover{border-color:#0d7377;background:#e0f7f3;}
  .am-auth-icon{font-size:1.6rem;margin-bottom:8px;}
  .am-auth-label{font-family:'Poppins',sans-serif;font-size:.95rem;font-weight:600;color:#0d4a55;}
  .am-auth-sub{font-size:.8rem;color:#6a9aa2;margin-top:4px;}

  /* Form */
  .am-label{display:block;font-size:.75rem;font-weight:700;color:#4a7a82;text-transform:uppercase;letter-spacing:.07em;margin-bottom:4px;margin-top:12px;}
  .am-req{color:#c04030;}
  .am-input{width:100%;padding:9px 12px;border:1.5px solid #c5e5e8;border-radius:10px;font-family:'Nunito',sans-serif;font-size:.92rem;color:#1a3a4a;background:#f5fcfd;outline:none;transition:border-color .2s;}
  .am-input:focus{border-color:#0d7377;background:#fff;}
  .am-textarea{resize:vertical;min-height:72px;}
  .am-grid2{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
  .am-otp-row{display:grid;grid-template-columns:1fr auto;gap:8px;align-items:end;}
  .am-otp-btn{padding:9px 13px;background:#e0f7f3;border:1.5px solid #b0ddd8;color:#0d7377;border-radius:10px;font-family:'Nunito',sans-serif;font-weight:700;font-size:.82rem;cursor:pointer;white-space:nowrap;}
  .am-otp-btn:hover{background:#c8f0e8;}
  .am-select{width:100%;padding:9px 12px;border:1.5px solid #c5e5e8;border-radius:10px;font-family:'Nunito',sans-serif;font-size:.92rem;color:#1a3a4a;background:#f5fcfd;outline:none;cursor:pointer;}
  .am-select:focus{border-color:#0d7377;}

  /* Autosuggest */
  .am-suggest-wrap{position:relative;}
  .am-suggest-list{position:absolute;top:100%;left:0;right:0;background:#fff;border:1.5px solid #c5e5e8;border-radius:10px;z-index:999;max-height:160px;overflow-y:auto;margin-top:2px;box-shadow:0 8px 20px rgba(13,115,119,.1);}
  .am-suggest-item{padding:9px 13px;font-size:.88rem;cursor:pointer;color:#1a3a4a;transition:background .15s;}
  .am-suggest-item:hover{background:#e0f7f3;color:#0d4a55;}

  /* Tag input */
  .am-tags-box{display:flex;flex-wrap:wrap;gap:6px;padding:7px 10px;border:1.5px solid #c5e5e8;border-radius:10px;background:#f5fcfd;cursor:text;min-height:42px;}
  .am-tag{display:flex;align-items:center;gap:4px;background:#e0f7f3;border:1px solid #9ad8d0;border-radius:20px;padding:3px 9px 3px 11px;font-size:.8rem;font-weight:700;color:#0d4a55;}
  .am-tag button{background:none;border:none;cursor:pointer;color:#c04030;font-size:.85rem;padding:0;line-height:1;font-weight:900;}
  .am-tag-input{border:none;outline:none;background:transparent;font-family:'Nunito',sans-serif;font-size:.88rem;color:#1a3a4a;min-width:120px;flex:1;}

  /* Upload */
  .am-upload{border:2px dashed #b0ddd8;border-radius:12px;padding:18px;text-align:center;cursor:pointer;transition:all .2s;background:#f5fcfd;}
  .am-upload:hover{border-color:#0d7377;background:#e8f8f5;}
  .am-upload input{display:none;}
  .am-upload-icon{font-size:1.6rem;margin-bottom:6px;}
  .am-upload-text{font-size:.85rem;color:#5a8a94;}
  .am-upload-text span{color:#0d7377;font-weight:700;}
  .am-upload-done{font-size:.85rem;color:#0d7377;font-weight:700;margin-top:6px;}

  /* Buttons */
  .am-btn-primary{width:100%;margin-top:16px;padding:12px;background:linear-gradient(135deg,#0d7377,#14a085);color:#fff;border:none;border-radius:11px;font-family:'Poppins',sans-serif;font-weight:600;font-size:.95rem;cursor:pointer;transition:all .2s;box-shadow:0 4px 14px rgba(13,115,119,.25);}
  .am-btn-primary:hover{transform:translateY(-1px);box-shadow:0 7px 20px rgba(13,115,119,.35);}
  .am-btn-primary:disabled{opacity:.6;cursor:not-allowed;transform:none;}
  .am-note{font-size:.8rem;color:#6a9aa2;text-align:center;margin-top:10px;}
  .am-note a{color:#0d7377;cursor:pointer;font-weight:700;text-decoration:none;}
  .am-error{font-size:.82rem;color:#c04030;margin-top:6px;font-weight:600;}

  /* Success */
  .am-success{text-align:center;padding:16px 0 8px;}
  .am-success-icon{font-size:3rem;margin-bottom:12px;}
  .am-success-title{font-family:'Poppins',sans-serif;font-size:1.15rem;font-weight:700;color:#0d4a55;margin-bottom:6px;}
  .am-success-sub{font-size:.88rem;color:#5a8a94;line-height:1.55;}
  .am-id-box{margin-top:14px;padding:11px 16px;background:#e8f8f5;border:1px solid #b0ddd8;border-radius:10px;font-size:.85rem;color:#5a8a94;}
  .am-id-box strong{color:#0d4a55;font-weight:800;}

  @media(max-width:500px){
    .am-role-grid{grid-template-columns:1fr;}
    .am-auth-grid{grid-template-columns:1fr;}
    .am-grid2{grid-template-columns:1fr;}
  }
`;

/* ─── Small reusable autosuggest hook ─── */
function useSuggest(list) {
  const [show, setShow] = useState(false);
  const [items, setItems] = useState([]);
  const search = (val) => {
    const q = val.toLowerCase();
    setItems(q ? list.filter((x) => x.toLowerCase().includes(q)).slice(0, 7) : []);
    setShow(true);
  };
  const hide = () => setTimeout(() => setShow(false), 160);
  return { show, items, search, hide };
}

export default function AuthModal({ job, onClose, onSuccess }) {
  /* ── navigation state ── */
  const [step, setStep]   = useState("role");   // role | authChoice | login | reg1 | reg2 | reg3 | success
  const [role, setRole]   = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* ── login fields ── */
  const [loginPhone, setLoginPhone] = useState("");
  const [loginPass,  setLoginPass]  = useState("");

  /* ── register step 1 ── */
  const [fname,     setFname]     = useState("");
  const [lname,     setLname]     = useState("");
  const [regPhone,  setRegPhone]  = useState("");
  const [otp,       setOtp]       = useState("");
  const [otpSent,   setOtpSent]   = useState(false);
  const [regEmail,  setRegEmail]  = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const [regPass,   setRegPass]   = useState("");
  const [regPass2,  setRegPass2]  = useState("");

  /* ── register step 2 ── */
  const [degree,    setDegree]    = useState("");
  const [spec,      setSpec]      = useState("");
  const [inst,      setInst]      = useState("");
  const [year,      setYear]      = useState("");
  const [expLevel,  setExpLevel]  = useState("");
  const [titleTags, setTitleTags] = useState([]);
  const [tagInput,  setTagInput]  = useState("");

  /* ── register step 3 ── */
  const [resumeFile,  setResumeFile]  = useState(null);
  const [resumeB64,   setResumeB64]   = useState("");
  const [coverNote,   setCoverNote]   = useState("");

  /* ── success ── */
  const [seekerId, setSeekerId] = useState("");

  /* ── autosuggest ── */
  const degSuggest  = useSuggest(DEGREES);
  const specSuggest = useSuggest(SPECS);
  const instSuggest = useSuggest(INSTS);
  const titleSuggest = useSuggest(JOB_TITLES);

  const tagRef     = useRef();
  const resumeRef  = useRef();

  /* ─── helpers ─── */
  const header = {
    role:       { title: "Apply for this job",          sub: job ? `"${job.title}" — select your role` : "Select your role to continue" },
    authChoice: { title: `Applying as ${role}`,         sub: "Already registered or new here?" },
    login:      { title: "Log in to apply",             sub: "Enter your credentials" },
    reg1:       { title: "Create your account",         sub: "Step 1 of 3 — Basic details" },
    reg2:       { title: "Education & qualifications",  sub: "Step 2 of 3" },
    reg3:       { title: "Upload resume",               sub: "Step 3 of 3" },
    success:    { title: "Application submitted! 🎉",   sub: "" },
  };

  const pills = { reg1:[1,0,0], reg2:[1,1,0], reg3:[1,1,1] };

  const goBack = () => {
    setError("");
    const map = { authChoice:"role", login:"authChoice", reg1:"authChoice", reg2:"reg1", reg3:"reg2" };
    if (map[step]) setStep(map[step]);
  };

  const showBack = !["role","success"].includes(step);

  /* ─── send OTP (demo) ─── */
  const sendOTP = () => {
    if (!regPhone) { setError("Enter phone number first."); return; }
    setOtpSent(true);
    setError("");
    alert(`OTP sent to ${regPhone} (demo mode — use any 6 digits)`);
  };

  /* ─── verify email (demo) ─── */
  const verifyEmail = () => {
    if (!regEmail) { setError("Enter email first."); return; }
    setEmailVerified(true);
    setError("");
    alert(`Verification link sent to ${regEmail} (demo mode)`);
  };

  /* ─── tag helpers ─── */
  const addTag = (val) => {
    const t = val.trim();
    if (t && !titleTags.includes(t)) setTitleTags((p) => [...p, t]);
    setTagInput("");
  };
  const removeTag = (t) => setTitleTags((p) => p.filter((x) => x !== t));
  const tagKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && tagInput) { e.preventDefault(); addTag(tagInput); }
    if (e.key === "Backspace" && !tagInput && titleTags.length) removeTag(titleTags[titleTags.length - 1]);
  };

  /* ─── resume handler ─── */
  const handleResume = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 3 * 1024 * 1024) { setError("File too large — max 3 MB."); return; }
    setResumeFile(file);
    const reader = new FileReader();
    reader.onload = (ev) => setResumeB64(ev.target.result);
    reader.readAsDataURL(file);
    setError("");
  };

  /* ─── LOGIN ─── */
  const handleLogin = async () => {
    setError("");
    if (!loginPhone || !loginPass) { setError("Please fill in all fields."); return; }
    setLoading(true);
    try {
      // Look up seeker by phone in Firebase
      const snap = await get(ref(database, "seekers"));
      if (snap.exists()) {
        const allSeekers = snap.val();
        const match = Object.values(allSeekers).find(
          (s) => s.phone1 === loginPhone && s.password === loginPass
        );
        if (match) {
          setSeekerId(match.seekerId || "SKR-" + loginPhone.slice(-5));
          setStep("success");
        } else {
          setError("Invalid phone number or password.");
        }
      } else {
        setError("No accounts found. Please register.");
      }
    } catch (err) {
      setError("Login failed. Please try again.");
    }
    setLoading(false);
  };

  /* ─── REGISTER step 1 → 2 ─── */
  const handleReg1Next = () => {
    setError("");
    if (!fname || !lname)   { setError("Please enter your full name."); return; }
    if (!regPhone)          { setError("Phone number is required."); return; }
    if (!otp && otpSent)    { setError("Please enter the OTP."); return; }
    if (!regEmail)          { setError("Email address is required."); return; }
    if (!regPass)           { setError("Password is required."); return; }
    if (regPass.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (regPass !== regPass2){ setError("Passwords do not match."); return; }
    setStep("reg2");
  };

  /* ─── REGISTER step 2 → 3 ─── */
  const handleReg2Next = () => {
    setError("");
    if (!degree)   { setError("Degree / qualification is required."); return; }
    if (!inst)     { setError("Institution is required."); return; }
    if (!expLevel) { setError("Please select your experience level."); return; }
    setStep("reg3");
  };

  /* ─── REGISTER step 3 → submit ─── */
  const handleSubmit = async () => {
    setError("");
    if (!resumeFile) { setError("Please upload your resume."); return; }
    setLoading(true);
    try {
      const newId = "SKR-" + Date.now().toString().slice(-6);
      const seekerData = {
        seekerId:     newId,
        role,
        name:         `${fname} ${lname}`,
        phone1:       regPhone,
        email:        regEmail,
        password:     regPass,           // NOTE: hash this server-side in production!
        education:    [{ degree, institute: inst, year }],
        specialization: spec,
        experience:   expLevel,
        jobTitles:    titleTags,
        resumeName:   resumeFile.name,
        resumeBase64: resumeB64,
        coverNote,
        appliedJobs:  job ? [job.id || job.postedAt] : [],
        createdAt:    new Date().toISOString(),
      };
      await set(ref(database, `seekers/${newId}`), seekerData);
      setSeekerId(newId);
      setStep("success");
    } catch (err) {
      setError("Registration failed. Please try again.");
    }
    setLoading(false);
  };

  /* ─── render ─── */
  const h = header[step] || header.role;

  return (
    <>
      <style>{styles}</style>
      <div className="am-overlay" onClick={onClose}>
        <div className="am-modal" onClick={(e) => e.stopPropagation()}>

          {/* Header */}
          <div className="am-header">
            {showBack && (
              <button className="am-back" onClick={goBack} title="Back">←</button>
            )}
            <h2 style={{ marginLeft: showBack ? "36px" : 0 }}>{h.title}</h2>
            {h.sub && <p style={{ marginLeft: showBack ? "36px" : 0 }}>{h.sub}</p>}
            <button className="am-close" onClick={onClose} title="Close">✕</button>
          </div>

          <div className="am-body">

            {/* ── STEP: role ── */}
            {step === "role" && (
              <>
                <div style={{ fontSize: ".88rem", color: "#5a8a94", marginBottom: 14 }}>
                  Who are you applying as?
                </div>
                <div className="am-role-grid">
                  {[
                    { key:"Job Seeker/Applicant ", icon:"🧑‍⚕️", sub:"Nurse, Paramedical, Allied…" },
                    { key:"Doctor",     icon:"👨‍⚕️", sub:"MBBS, BDS, BAMS, MD…" },
                    { key:"Other",      icon:"👥",    sub:"Admin, Lab, Pharma…" },
                  ].map((r) => (
                    <div
                      key={r.key}
                      className="am-role-card"
                      onClick={() => { setRole(r.key); setStep("authChoice"); }}
                    >
                      <div className="am-role-icon">{r.icon}</div>
                      <div className="am-role-label">{r.key}</div>
                      <div className="am-role-sub">{r.sub}</div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* ── STEP: authChoice ── */}
            {step === "authChoice" && (
              <>
                <div style={{ fontSize: ".88rem", color: "#5a8a94", marginBottom: 14 }}>
                  Already have an account or signing up fresh?
                </div>
                <div className="am-auth-grid">
                  <div className="am-auth-card" onClick={() => setStep("login")}>
                    <div className="am-auth-icon">🔑</div>
                    <div className="am-auth-label">Log in</div>
                    <div className="am-auth-sub">I already have an account</div>
                  </div>
                  <div className="am-auth-card" onClick={() => setStep("reg1")}>
                    <div className="am-auth-icon">✨</div>
                    <div className="am-auth-label">Register</div>
                    <div className="am-auth-sub">Create a new account</div>
                  </div>
                </div>
              </>
            )}

            {/* ── STEP: login ── */}
            {step === "login" && (
              <>
                <label className="am-label">Phone number <span className="am-req">*</span></label>
                <input
                  className="am-input"
                  type="tel"
                  placeholder="+91 98765 43210"
                  value={loginPhone}
                  onChange={(e) => setLoginPhone(e.target.value)}
                />
                <label className="am-label">Password <span className="am-req">*</span></label>
                <input
                  className="am-input"
                  type="password"
                  placeholder="Your password"
                  value={loginPass}
                  onChange={(e) => setLoginPass(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                />
                {error && <div className="am-error">⚠ {error}</div>}
                <button className="am-btn-primary" onClick={handleLogin} disabled={loading}>
                  {loading ? "Logging in…" : "Log in & Apply →"}
                </button>
                <p className="am-note">
                  No account? <a onClick={() => { setError(""); setStep("reg1"); }}>Register here</a>
                </p>
              </>
            )}

            {/* ── STEP: reg1 — basic details ── */}
            {step === "reg1" && (
              <>
                <div className="am-pills">
                  {[1,0,0].map((d, i) => <div key={i} className={`am-pill ${d ? "done" : ""}`} />)}
                </div>
                <div className="am-grid2">
                  <div>
                    <label className="am-label">First name <span className="am-req">*</span></label>
                    <input className="am-input" placeholder="Priya" value={fname} onChange={(e) => setFname(e.target.value)} />
                  </div>
                  <div>
                    <label className="am-label">Last name <span className="am-req">*</span></label>
                    <input className="am-input" placeholder="Sharma" value={lname} onChange={(e) => setLname(e.target.value)} />
                  </div>
                </div>

                <label className="am-label">Phone number <span className="am-req">*</span></label>
                <div className="am-otp-row">
                  <input
                    className="am-input"
                    type="tel"
                    placeholder="+91 98765 43210"
                    value={regPhone}
                    onChange={(e) => setRegPhone(e.target.value)}
                  />
                  <button className="am-otp-btn" onClick={sendOTP}>
                    {otpSent ? "Resend" : "Send OTP"}
                  </button>
                </div>

                {otpSent && (
                  <>
                    <label className="am-label">Enter OTP <span className="am-req">*</span></label>
                    <input
                      className="am-input"
                      placeholder="6-digit OTP"
                      maxLength={6}
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </>
                )}

                <label className="am-label">Email address <span className="am-req">*</span></label>
                <div className="am-otp-row">
                  <input
                    className="am-input"
                    type="email"
                    placeholder="priya@email.com"
                    value={regEmail}
                    onChange={(e) => { setRegEmail(e.target.value); setEmailVerified(false); }}
                  />
                  <button className="am-otp-btn" onClick={verifyEmail}>
                    {emailVerified ? "✓ Sent" : "Verify"}
                  </button>
                </div>

                <label className="am-label">Password <span className="am-req">*</span></label>
                <input
                  className="am-input"
                  type="password"
                  placeholder="Min 8 characters"
                  value={regPass}
                  onChange={(e) => setRegPass(e.target.value)}
                />

                <label className="am-label">Confirm password <span className="am-req">*</span></label>
                <input
                  className="am-input"
                  type="password"
                  placeholder="Repeat password"
                  value={regPass2}
                  onChange={(e) => setRegPass2(e.target.value)}
                />

                {error && <div className="am-error">⚠ {error}</div>}
                <button className="am-btn-primary" onClick={handleReg1Next}>
                  Next — Education →
                </button>
                <p className="am-note">
                  Already registered? <a onClick={() => { setError(""); setStep("login"); }}>Log in</a>
                </p>
              </>
            )}

            {/* ── STEP: reg2 — education ── */}
            {step === "reg2" && (
              <>
                <div className="am-pills">
                  {[1,1,0].map((d, i) => <div key={i} className={`am-pill ${d ? "done" : ""}`} />)}
                </div>

                {/* Degree */}
                <label className="am-label">Degree / Qualification <span className="am-req">*</span></label>
                <div className="am-suggest-wrap">
                  <input
                    className="am-input"
                    placeholder="e.g. MBBS, BDS, BSc Nursing…"
                    value={degree}
                    onChange={(e) => { setDegree(e.target.value); degSuggest.search(e.target.value); }}
                    onFocus={() => degSuggest.search(degree)}
                    onBlur={degSuggest.hide}
                    autoComplete="off"
                  />
                  {degSuggest.show && degSuggest.items.length > 0 && (
                    <div className="am-suggest-list">
                      {degSuggest.items.map((d) => (
                        <div key={d} className="am-suggest-item" onMouseDown={() => { setDegree(d); degSuggest.hide(); }}>
                          {d}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Specialization */}
                <label className="am-label">Specialization</label>
                <div className="am-suggest-wrap">
                  <input
                    className="am-input"
                    placeholder="e.g. Cardiology, ICU, Physiotherapy…"
                    value={spec}
                    onChange={(e) => { setSpec(e.target.value); specSuggest.search(e.target.value); }}
                    onFocus={() => specSuggest.search(spec)}
                    onBlur={specSuggest.hide}
                    autoComplete="off"
                  />
                  {specSuggest.show && specSuggest.items.length > 0 && (
                    <div className="am-suggest-list">
                      {specSuggest.items.map((s) => (
                        <div key={s} className="am-suggest-item" onMouseDown={() => { setSpec(s); specSuggest.hide(); }}>
                          {s}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Institution */}
                <label className="am-label">Institution / College <span className="am-req">*</span></label>
                <div className="am-suggest-wrap">
                  <input
                    className="am-input"
                    placeholder="e.g. AIIMS, KEM Mumbai…"
                    value={inst}
                    onChange={(e) => { setInst(e.target.value); instSuggest.search(e.target.value); }}
                    onFocus={() => instSuggest.search(inst)}
                    onBlur={instSuggest.hide}
                    autoComplete="off"
                  />
                  {instSuggest.show && instSuggest.items.length > 0 && (
                    <div className="am-suggest-list">
                      {instSuggest.items.map((i) => (
                        <div key={i} className="am-suggest-item" onMouseDown={() => { setInst(i); instSuggest.hide(); }}>
                          {i}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="am-grid2">
                  <div>
                    <label className="am-label">Year of passing</label>
                    <input
                      className="am-input"
                      placeholder="2020"
                      maxLength={4}
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="am-label">Experience <span className="am-req">*</span></label>
                    <select
                      className="am-select"
                      value={expLevel}
                      onChange={(e) => setExpLevel(e.target.value)}
                    >
                      <option value="">Select…</option>
                      <option>Fresher (0 yrs)</option>
                      <option>0–2 years</option>
                      <option>2–5 years</option>
                      <option>5–10 years</option>
                      <option>10+ years</option>
                    </select>
                  </div>
                </div>

                {/* Job Titles tag input */}
                <label className="am-label">Job titles you're open to</label>
                <div className="am-tags-box" onClick={() => tagRef.current.focus()}>
                  {titleTags.map((t) => (
                    <span key={t} className="am-tag">
                      {t}
                      <button type="button" onClick={() => removeTag(t)}>×</button>
                    </span>
                  ))}
                  <input
                    ref={tagRef}
                    className="am-tag-input"
                    placeholder="Type and press Enter…"
                    value={tagInput}
                    onChange={(e) => { setTagInput(e.target.value); titleSuggest.search(e.target.value); }}
                    onFocus={() => titleSuggest.search(tagInput)}
                    onBlur={() => { titleSuggest.hide(); if (tagInput) addTag(tagInput); }}
                    onKeyDown={tagKeyDown}
                    autoComplete="off"
                  />
                </div>
                {titleSuggest.show && titleSuggest.items.length > 0 && (
                  <div className="am-suggest-list" style={{ position:"relative", marginTop:2 }}>
                    {titleSuggest.items.filter((t) => !titleTags.includes(t)).map((t) => (
                      <div key={t} className="am-suggest-item" onMouseDown={() => { addTag(t); titleSuggest.hide(); }}>
                        {t}
                      </div>
                    ))}
                  </div>
                )}

                {error && <div className="am-error">⚠ {error}</div>}
                <button className="am-btn-primary" onClick={handleReg2Next}>
                  Next — Upload Resume →
                </button>
              </>
            )}

            {/* ── STEP: reg3 — resume ── */}
            {step === "reg3" && (
              <>
                <div className="am-pills">
                  {[1,1,1].map((d, i) => <div key={i} className={`am-pill ${d ? "done" : ""}`} />)}
                </div>

                <div
                  className="am-upload"
                  onClick={() => resumeRef.current.click()}
                >
                  <input ref={resumeRef} type="file" accept=".pdf,.doc,.docx" onChange={handleResume} />
                  <div className="am-upload-icon">📄</div>
                  {resumeFile ? (
                    <div className="am-upload-done">✓ {resumeFile.name}</div>
                  ) : (
                    <div className="am-upload-text">
                      <span>Click to upload</span> your resume<br />
                      <small style={{ color:"#8aacb2" }}>PDF, DOC, DOCX — max 3 MB</small>
                    </div>
                  )}
                </div>

                <label className="am-label">Cover note (optional)</label>
                <textarea
                  className="am-input am-textarea"
                  placeholder="Briefly introduce yourself and why you're a great fit…"
                  value={coverNote}
                  onChange={(e) => setCoverNote(e.target.value)}
                  rows={3}
                />

                {error && <div className="am-error">⚠ {error}</div>}
                <button className="am-btn-primary" onClick={handleSubmit} disabled={loading}>
                  {loading ? "Submitting…" : "🚀 Submit Application"}
                </button>
              </>
            )}

            {/* ── STEP: success ── */}
            {step === "success" && (
              <div className="am-success">
                <div className="am-success-icon">🎉</div>
                <div className="am-success-title">Application Submitted!</div>
                <div className="am-success-sub">
                  Your application for <strong>{job?.title}</strong> has been sent.<br />
                  The employer will reach you by phone or email.
                </div>
                <div className="am-id-box">
                  🪪 Your Seeker ID: <strong>{seekerId}</strong>
                </div>
                <button
                  className="am-btn-primary"
                  style={{ marginTop: 18 }}
                  onClick={onSuccess}
                >
                  Done ✓
                </button>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}